var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"rules":_vm.rules,"items":_vm.items,"name":"unit","label":"Unidade"}},'v-select',_vm.fieldProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }